import { extends as _extends } from '../../../_virtual/_rollupPluginBabelHelpers.js';
import React from 'react';
import PropTypes from 'prop-types';
import { DisplayConfiguration } from './DisplayConfiguration.js';
import { pickDataAttributes } from '../../../utils/pickDataAttributes.js';

var DisplayFlexColumns = function DisplayFlexColumns(props) {
  var _props$children;

  var dataAttributes = pickDataAttributes(props, 'display-flex-columns');
  var styles = [];

  if ((_props$children = props.children) !== null && _props$children !== void 0 && _props$children.length) {
    props.children.forEach(function () {
      return styles.push({
        flex: '1'
      });
    });
  }

  return /*#__PURE__*/React.createElement(DisplayConfiguration, _extends({}, props, {
    styles: styles
  }, dataAttributes, {
    className: "display-flex-column",
    configContainerClass: "display-flex-columns"
  }));
};

DisplayFlexColumns.displayName = "DisplayFlexColumns";
DisplayFlexColumns.propTypes = {
  children: PropTypes.node
};
export { DisplayFlexColumns };